package com.jingfangpai.diagnosisSetting.model

import com.jingfangpai.common.orm.mapping.DiagnosisSetting
import kotlinx.serialization.Serializable

@Serializable
data class DiagnosisSettings(var system:Array<DiagnosisSettingDto> = arrayOf(), var organization:Array<DiagnosisSettingDto> = arrayOf(), var personal:Array<DiagnosisSettingDto> = arrayOf())
